import React from 'react';
import ContentLoader from 'react-content-loader';

export default function LoadingFunds() {
  return (
    <ContentLoader
      speed={2}
      height={25}
      viewBox="0 0 100 100"
      backgroundColor="#f3f3f3"
      foregroundColor="#ecebeb"
      className="w-100 loading-funds"
      preserveAspectRatio="none"
    >
      <rect x="0" y="0" rx="0" ry="0" width="100%" height="100%" />
    </ContentLoader>
  );
}
